<template>
  <div>
    <div style="color: #cfcfcf; font-size: 13px">未来7日气温预测</div>
    <div id="chart-coming" style="height: 180px"></div>
    <!-- <img src="./pic/left15days.png" alt="" /> -->
  </div>
</template>
<script>
import axios from 'axios'
import Charts from '@jiaminghi/charts'
export default {
  data() {
    return {}
  },
  created() {},
  mounted() {
    setTimeout(() => {
      console.log('echarts = ', Charts)
      this.chart = new Charts(document.getElementById('chart-coming'))
      axios
        .get('http://berry-internet.zkhfzhnyg.cn/api/weather/coming7days')
        .then((resp) => {
          console.log('weather', resp.data)
          const seq = []
          const series1 = []
          const series2 = []
          resp.data.forEach((item) => {
            seq.push('')
            series1.push(item.tempLow)
            series2.push(item.tempHigh)
          })
          this.drawChart(seq, series1, series2)
        })
    })
  },
  methods: {
    drawChart(seq, series1, series2) {
      this.chart.setOption({
        title: { show: false },
        grid: { left: 0, right: 0 },
        xAxis: {
          data: seq,
          boundaryGap: true,
        },
        yAxis: {
          data: 'value',
          splitLine: { show: false },
          axisLine: { show: false },
          axisLabel: { show: false },
          axisTick: { show: false },
        },
        series: [
          {
            data: series1,
            type: 'line',
            label: {
              show: true,
            },
          },
          {
            data: series2,
            type: 'line',
            label: {
              show: true,
            },
          },
        ],
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
        },
      })
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen38496/weather-zone/chart-coming.vue